// extracted by mini-css-extract-plugin
export default {"game_statistic_card":"GameStatistic_game_statistic_card__jaYiC","game_statistics_table":"GameStatistic_game_statistics_table__7VPZf"};